// extracted by mini-css-extract-plugin
export var addButton = "_4g-d";
export var bullets = "_4g-e";
export var compact = "_4g-2";
export var container = "_4g-j";
export var extendedWarrantyModal = "_4g-f";
export var learn = "_4g-l";
export var learnMore = "_4g-g";
export var offeringOption = "_4g-3";
export var offeringPrice = "_4g-8";
export var offeringSubtitle = "_4g-7";
export var offeringTitle = "_4g-6";
export var offeringsContainer = "_4g-0";
export var pdpTilesBackground = "_4g-n";
export var plan = "_4g-m";
export var regular = "_4g-1";
export var remove = "_4g-k";
export var seeDetailsIcon = "_4g-i";
export var seeDetailsLink = "_4g-h";
export var selectedOption = "_4g-4";
export var shieldIcon = "_4g-b";
export var shieldIconCompact = "_4g-c";
export var subtitle = "_4g-a";
export var title = "_4g-9";
export var unselectedOption = "_4g-5";